import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import axiosAuth from "@/services/axiosAuth";
import { DASHBOARD_STAT } from "./apiRoutes";

interface UseGetVendorGlSpendProps {
  year: string;
  communityId: string;
  queryParams?: Omit<UseQueryOptions, "queryKey">;
}

const getVendorGlSpend = async (communityId: string, year: string) =>
  await axiosAuth.get(
    `${DASHBOARD_STAT(communityId)}/vendors-gl/spend?budgetYear=${year}`
  );

const useGetVendorsGlSpend = ({
  year,
  communityId,
  queryParams,
}: UseGetVendorGlSpendProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["vendor-gl-spend", communityId, year],
    queryFn: () => getVendorGlSpend(communityId, year),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    enabled: queryParams?.enabled,
    ...queryParams,
  });
};

export default useGetVendorsGlSpend;
